import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h2nuzyq4qg: FaireBrandEntity = {
  token: "b_h2nuzyq4qg",
  type: "brand",
  name: "Standard Wax",
  avatarUrl:
    "https://cdn.faire.com/fastly/823f038f74c8e891e56c2f80a8205dae909a5803b93e4289ba0baf8a452a9ce5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6ac0d10e3570543755b116166def4a8288a8d92046e3482f8dd0485506f063f1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/823f038f74c8e891e56c2f80a8205dae909a5803b93e4289ba0baf8a452a9ce5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6ac0d10e3570543755b116166def4a8288a8d92046e3482f8dd0485506f063f1.jpeg",
  location: "Perrysburg, OH, USA",
  minimumOrderDollars: 15,
  rating: 5,
  reviewCount: 16,
  isInsider: true,
  description:
    'Standard Wax is a small women-run and led, hand-poured candle studio based in Perrysburg, Ohio. We use focus on white label candles, diffusers, and gift sets and try to make it easy for business small and large to create their own custom products. We specialize in premium fragrances and designer "inspired by" scents to give your candle an elevated feel! \n\nAt Standard Wax we use premium ingredients to make the best products. Our candles are made from soy wax and all: \n- Carcinogen free\n- Phthalate free\n- Mutagen free\n- Reproductive toxin free\n- Acute toxin free',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:43.408Z",
    importedBy: "entity-db-cli",
  },
};
